const projectObject = {
    pageTitle: "LATEST PROJECTS",
    one: {
        project: "Project | 01",
        title: "Yves Arthur Freelancer",
        paragraph: "My own webiste made using React-JS",
        link: "https://yvesarthurstudio",
        github: "https://github.com/LilithinMerria/my_website_react"
    },

    first: {
      project: "Project | 02",
      title: "Yves Arthur",
      paragraph: "My own website made with html5, css3, and javascript via js-injection method.",
      link: "https://silver-muse.web.app",
      github: "https://github.com/LilithinMerria/my_website"
    },
    second : {
      project: "Project | 03",
      title: "Jaie Why",
      paragraph: "A website for one of the reggae musicians in Nepal.",
      link: "https://jaiewhy.web.app/",
      github: "https://github.com/LilithinMerria/JaieWhyPro"
    },
    third: {
      project: "Project | 04",
      title: "Microsoft Stock Market Analysis (Git Repository)",
      paragraph: "Analysing a Microsoft Stock Market Dataset and making a Simple Trading Strategy  using Python.",
      github: "https://github.com/LilithinMerria/microsoftstockanalysis"
    },
    fourth: {
      project: "Project | 05",
      title: "Garden Web Application",
      paragraph: "Building a Web Application with Reactjs",
      link: "https://mygarden-54713.web.app/home",
      github: "https://github.com/LilithinMerria/garden"
    },
    fifth: {
      project: "Project | 06",
      title: "Automobile Analysis",
      paragraph: "Analysing an automobile dataset in order to predict the price based on the features provided.",
      github: "https://github.com/LilithinMerria/automobile_analysis"
    }
  };

  export default projectObject;